import * as React from 'react';
import styles from './index.module.scss';
import cx from 'classnames';
import { HubFile } from '../../model';
import { useDispatch } from 'react-redux';
import { getFile } from '../../store/Story/actions';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import FileItem from '../FileItem';
import moment from 'moment';

const LazyFileItem = ({
    fileId,
    actionIcon,
    onItemClick,
    onCheckedChange,
    hover,
    selected,
    checked,
    isMobile,
    disableClick,
    shareStatus,
    ...props
}: {
    fileId: number;
    actionIcon: string;
    selected: boolean;
    checked: boolean;
    hover: boolean;
    onItemClick?: (id: number) => void;
    onCheckedChange?: (id: number, checked: boolean) => void;
    isMobile?: boolean;
    disableClick?: boolean;
    shareStatus?: string;
} & React.HtmlHTMLAttributes<HTMLDivElement>) => {
    const dispatch = useDispatch();
    const [item, setItem] = React.useState({
        story: {

        }
    } as HubFile);

    const {
        files
    } = useTypedSelector((state: ApplicationState) => state.story);

    React.useEffect(() => {
        if (fileId) {
            if (!files[fileId]) {
                dispatch(getFile(fileId));
            } else {
                setItem(files[fileId]);
            }
        }
    }, [fileId, files[fileId]]);
    const rootClass = cx(styles.root, selected && styles.selected, hover && styles.hover);
    let date = "";
    if (item) {
        date = moment(new Date(1500267303 * 1000)).format("MMM D");
    }

    const renderFile = () => {
        return (
            <FileItem
                category={item.category}
                onCheckedItemChange={(id, checked) => onCheckedChange && onCheckedChange(id, checked)}
                showChecked={true}
                big
                disable={false}
                checked={checked}
                onItemClick={() => item.filePermId && onItemClick && onItemClick(item.filePermId)}
                metaData={date}
                id={item.id}
                title={item.description}
                thumbnail={item.thumbnail}
                isMobile={isMobile}
                shareStatus={shareStatus}
                disableClick={disableClick}/>
        )
    };

    return (
        <>
            {!isMobile && <div draggable className={rootClass} {...props}> {renderFile()} </div>}
            {isMobile && renderFile()}
        </>
    );
};

export default LazyFileItem